import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";

import { useAuthStore } from "@/auth/store";

export const Route = createFileRoute("/login")({
  component: LoginPage,
});

function LoginPage() {
  const navigate = useNavigate();
  const { login, isLoading, isLoggedIn } = useAuthStore();

  useEffect(() => {
    if (isLoading || isLoggedIn) {
      return;
    }
    login();
  }, [isLoading, isLoggedIn, login]);

  useEffect(() => {
    if (isLoggedIn) {
      navigate({ to: "/dashboard" });
    }
  }, [isLoggedIn, navigate]);

  return (
    <div className="flex h-screen items-center justify-center">
      <p className="text-body2">Redirecting to login…</p>
    </div>
  );
}
